(function () {
  var existingPerf = window.PongbotPerf || {};
  if (existingPerf.__pongbot26Ready) return;

  var splideCss = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css';
  var splideJs = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';
  var splidePromise = null;

  function loadStyleOnce(id, href) {
    if (document.getElementById(id)) return;
    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadScriptOnce(id, src) {
    var existing = document.getElementById(id);
    if (existing) {
      return existing.dataset.loaded === 'true'
        ? Promise.resolve()
        : new Promise(function (resolve, reject) {
            existing.addEventListener('load', resolve, { once: true });
            existing.addEventListener('error', reject, { once: true });
          });
    }

    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.async = true;
      script.onload = function () {
        script.dataset.loaded = 'true';
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadSplide() {
    if (window.Splide) return Promise.resolve(window.Splide);
    if (!splidePromise) {
      loadStyleOnce('pongbot26-splide-css', splideCss);
      splidePromise = loadScriptOnce('pongbot26-splide-js', splideJs).then(function () {
        return window.Splide;
      });
    }
    return splidePromise;
  }

  function onVisible(element, callback, options) {
    if (!element) return;
    var fired = false;
    function run() {
      if (fired) return;
      fired = true;
      callback();
    }

    if (!('IntersectionObserver' in window)) {
      run();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.intersectionRatio > 0) {
          observer.disconnect();
          run();
        }
      });
    }, options || { rootMargin: '500px 0px', threshold: 0.01 });

    observer.observe(element);
  }

  function onIdleOrInteraction(callback, timeout) {
    var fired = false;
    var timer = null;
    var events = ['pointerdown', 'keydown', 'touchstart', 'mousemove', 'scroll'];

    function cleanup() {
      events.forEach(function (eventName) {
        window.removeEventListener(eventName, run, passiveOptions);
      });
      if (timer) window.clearTimeout(timer);
    }

    function run() {
      if (fired) return;
      fired = true;
      cleanup();
      callback();
    }

    var passiveOptions = { once: true, passive: true };
    events.forEach(function (eventName) {
      window.addEventListener(eventName, run, passiveOptions);
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: timeout || 8000 });
    } else {
      timer = window.setTimeout(run, timeout || 8000);
    }
  }

  function loadDeferredMedia(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-srcset]').forEach(function (node) {
      node.setAttribute('srcset', node.getAttribute('data-srcset'));
      node.removeAttribute('data-srcset');
    });
    scope.querySelectorAll('[data-src]').forEach(function (node) {
      node.setAttribute('src', node.getAttribute('data-src'));
      node.removeAttribute('data-src');
    });
    scope.querySelectorAll('[data-bg]').forEach(function (node) {
      node.style.backgroundImage = "url('" + node.getAttribute('data-bg') + "')";
      node.removeAttribute('data-bg');
    });
  }

  var deferredModuleCallbacks = window.__pongbot26DeferredModules || [];
  var deferredModulesReleased = false;
  var deferredModulesScheduled = false;

  function isHomePage() {
    var path = window.location.pathname.replace(/\/+$/, '');
    return path === '' || path === '/';
  }

  function releaseDeferredModules() {
    if (deferredModulesReleased) return;
    deferredModulesReleased = true;
    var queue = deferredModuleCallbacks.splice(0);
    queue.forEach(function (callback) {
      try {
        callback();
      } catch (error) {
        window.setTimeout(function () {
          throw error;
        }, 0);
      }
    });
  }

  function scheduleDeferredModules() {
    if (deferredModulesScheduled) return;
    deferredModulesScheduled = true;
    var events = ['pointerdown', 'keydown', 'touchstart'];
    var passiveOptions = { once: true, passive: true, capture: true };
    var lcpTimer = null;
    var lcpObserver = null;

    function cleanup() {
      events.forEach(function (eventName) {
        window.removeEventListener(eventName, releaseAndCleanup, passiveOptions);
      });
      window.removeEventListener('pongbot26:load-modules', releaseAndCleanup);
      if (lcpTimer) window.clearTimeout(lcpTimer);
      if (lcpObserver) lcpObserver.disconnect();
    }

    function releaseAndCleanup() {
      cleanup();
      releaseDeferredModules();
    }

    function scheduleAfterLcp() {
      if (deferredModulesReleased || lcpTimer) return;
      lcpTimer = window.setTimeout(releaseAndCleanup, 3500);
    }

    events.forEach(function (eventName) {
      window.addEventListener(eventName, releaseAndCleanup, passiveOptions);
    });
    window.addEventListener('pongbot26:load-modules', releaseAndCleanup);
    if ('PerformanceObserver' in window) {
      try {
        lcpObserver = new PerformanceObserver(function (list) {
          if (list.getEntries().length) scheduleAfterLcp();
        });
        lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
      } catch (error) {
        lcpObserver = null;
      }
    }
    window.addEventListener('load', function () {
      window.setTimeout(releaseAndCleanup, 7000);
    }, { once: true });
  }

  function deferHomepageModule(callback) {
    if (typeof callback !== 'function') return;
    if (!isHomePage()) {
      callback();
      return;
    }
    if (deferredModulesReleased) {
      callback();
      return;
    }
    deferredModuleCallbacks.push(callback);
    scheduleDeferredModules();
  }

  window.PongbotPerf = Object.assign(existingPerf, {
    __pongbot26Ready: true,
    loadSplide: loadSplide,
    onVisible: onVisible,
    onIdleOrInteraction: onIdleOrInteraction,
    loadDeferredMedia: loadDeferredMedia,
    deferHomepageModule: deferHomepageModule,
    releaseDeferredModules: releaseDeferredModules
  });

  if (deferredModuleCallbacks.length) {
    scheduleDeferredModules();
  }

  function markHeroControlsReady() {
    document.documentElement.classList.add('pongbot26-hero-controls-ready');
  }

  if (document.readyState === 'complete') {
    markHeroControlsReady();
  } else {
    window.addEventListener('load', markHeroControlsReady, { once: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var backToTopButton = document.getElementById('back-to-top-button-jc');
    if (backToTopButton) {
      var ticking = false;
      function updateBackToTop() {
        ticking = false;
        backToTopButton.classList.toggle('is-visible', window.scrollY > 300);
      }
      function requestBackToTopUpdate() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(updateBackToTop);
      }
      window.addEventListener('scroll', requestBackToTopUpdate, { passive: true });
      window.addEventListener('resize', requestBackToTopUpdate, { passive: true });
      backToTopButton.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
      updateBackToTop();
    }

    var isInitialLoad = true;
    var originalScrollIntoView = Element.prototype.scrollIntoView;
    Element.prototype.scrollIntoView = function (options) {
      if (isInitialLoad) return;
      originalScrollIntoView.call(this, options);
    };
    window.addEventListener('load', function () {
      window.setTimeout(function () {
        isInitialLoad = false;
      }, 400);
    });

    function setBuyNowText() {
      document.querySelectorAll('shopify-buy-it-now-button .shopify-payment-button__button').forEach(function (btn) {
        if (btn && btn.textContent.trim() === 'Buy it now') {
          btn.textContent = 'Buy Now';
        }
      });
    }
    setBuyNowText();
    var paymentRoots = document.querySelectorAll('shopify-buy-it-now-button, .shopify-payment-button');
    if (paymentRoots.length) {
      var obs = new MutationObserver(setBuyNowText);
      paymentRoots.forEach(function (root) {
        obs.observe(root, { childList: true, subtree: true });
      });
      window.setTimeout(function () {
        obs.disconnect();
      }, 10000);
    }
  });

  (function () {
    function revealKlaviyo() {
      document.documentElement.classList.remove('pongbot26-delay-klaviyo');
    }
    window.addEventListener('pongbot26:late-third-party-released', revealKlaviyo, { once: true });
    window.addEventListener('load', function () {
      window.setTimeout(revealKlaviyo, 5000);
    }, { once: true });
  })();

  var currentScript = document.currentScript;
  var tidioSrc = currentScript && currentScript.getAttribute('data-tidio-src');
  if (tidioSrc) {
    (function () {
      var tidioLoaded = false;
      var events = ['pointerdown', 'keydown', 'touchstart'];
      var passiveOptions = { once: true, passive: true };

      function cleanup() {
        events.forEach(function (eventName) {
          window.removeEventListener(eventName, loadTidio, passiveOptions);
        });
      }

      function loadTidio() {
        if (tidioLoaded) return;
        tidioLoaded = true;
        cleanup();
        if (document.querySelector('script[data-pongbot26-tidio]')) return;
        var script = document.createElement('script');
        script.src = tidioSrc;
        script.async = true;
        script.dataset.pongbot26Tidio = 'true';
        document.body.appendChild(script);
      }

      events.forEach(function (eventName) {
        window.addEventListener(eventName, loadTidio, passiveOptions);
      });
      window.addEventListener('pongbot26:late-third-party-released', loadTidio, { once: true });
      window.addEventListener('load', function () {
        window.setTimeout(loadTidio, 5000);
      }, { once: true });
    })();
  }
})();
